module.exports = __webpack_public_path__ + "img/green-3-diamond-solid.f7ad528d.svg";